import { PageInfo } from 'lib/types/pageInfo';

export enum PageInfoFields {
  TOTAL_ITEMS = 'totalItems',
  PAGE = 'page',
  PER_PAGE = 'perPage',
  TOTAL_PAGES = 'totalPages',
  HAS_NEXT_PAGE = 'hasNextPage',
  HAS_PREVIOUS_PAGE = 'hasPreviousPage',
}

export const defaultPageInfo: PageInfo = {
  [PageInfoFields.TOTAL_ITEMS]: 0,
  [PageInfoFields.PAGE]: 1,
  [PageInfoFields.PER_PAGE]: 10,
  [PageInfoFields.TOTAL_PAGES]: 0,
  [PageInfoFields.HAS_NEXT_PAGE]: false,
  [PageInfoFields.HAS_PREVIOUS_PAGE]: false,
};
